import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { routes } from "@/lib/constants";
import { UserType } from "muminsmart-utils";

type SellerLayoutContentProps = {
  children: React.ReactNode;
  sessionUserType?: UserType;
};

const SellerLayoutContent = ({
  children,
  sessionUserType,
}: SellerLayoutContentProps) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const normalizedPath = pathname.replace(/\/$/, "");
  const isSignupRoute =
    normalizedPath === routes.seller.signup.replace(/\/$/, "");
  const sellerPathParts = normalizedPath.split("/").filter(Boolean);
  const isViewShopRoute =
    (normalizedPath === "/seller" && !!searchParams.get("id")) ||
    (sellerPathParts.length === 2 &&
      sellerPathParts[0] === "seller" &&
      !["home", "signup", "invoices", "my-shop"].includes(sellerPathParts[1]));

  if (
    !isSignupRoute &&
    !isViewShopRoute &&
    sessionUserType !== UserType.Seller
  ) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-140px)]">
        <p className="text-lg">You are not authorized to access this page.</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default SellerLayoutContent;
